import lastSeen from 'assets/core/js/module/last-seen'
import snippet from 'assets/core/js/page/homepage/content/snippet'
import dataLayer from 'assets/core/js/page/homepage/datalayer'
import searchForm from 'assets/themes/vacances-campings/js/module/searchForm'
import cms from 'assets/themes/vacances-campings/js/page/homepage/cms'
import searchFiltersSidePanel from 'assets/themes/vacances-campings/js/page/homepage/search-filters-side-panel'

document.addEventListener('DOMContentLoaded', function () {
  cms()
  searchFiltersSidePanel()
  dataLayer()

  searchForm()
  snippet()
  lastSeen()
})
